/**
 * Central site configuration.
 * Edit `legalEntity` here so it exactly matches the official registered company name.
 */
export const site = {
  brandName: 'Atlas Digital Hub',
  domain: 'atlasdigitalhub.com',
  legalEntity: 'Creative Future Commerce LLC',
  jurisdiction: 'Wyoming, United States',
  supportEmail: 'digitalhubatlas@gmail.com',
  privacyEmail: 'digitalhubatlas@gmail.com',
  copyrightYear: '2026',
  logoUrl:
    'https://cdn.magicpatterns.com/uploads/rd34zFvVKDJaEFCFgUkmtz/ATLAS_LOGO.jpg',
  lastUpdated: 'January 1, 2026',
}

export const offerings = [
  {
    title: 'Digital Guides & Educational Resources',
    description:
      'We create downloadable guides, learning materials and digital educational resources designed to help users learn practical topics in a simple and accessible way.',
    icon: 'book',
  },
  {
    title: 'Printable Templates & Creative Resources',
    description:
      'We offer printable materials, templates and downloadable resources for creative, practical and hobby-based uses.',
    icon: 'printer',
  },
  {
    title: 'DIY & Craft Learning Materials',
    description:
      'We develop digital resources focused on creative projects, step-by-step learning, and hands-on educational content for hobby and craft audiences.',
    icon: 'scissors',
  },
  {
    title: 'Puzzles & Digital Entertainment',
    description:
      'We publish downloadable puzzle-based and interactive digital entertainment products designed for fun, engagement and mental stimulation.',
    icon: 'puzzle',
  },
] as const

export const steps = [
  {
    title: 'Choose a digital product',
    description:
      'Customers select the digital content or resource that best fits their needs.',
  },
  {
    title: 'Complete your purchase securely',
    description:
      'Payments are processed through secure online checkout systems.',
  },
  {
    title: 'Receive digital access electronically',
    description:
      'After purchase, customers receive access to their digital content electronically. No physical shipping is involved.',
  },
] as const

export const values = [
  'Clear digital delivery',
  'Customer support',
  'Transparent policies',
  'Secure online transactions',
] as const
